import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";

import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

import * as VeeValidate from 'vee-validate';


Vue.use(VeeValidate);
Vue.prototype.$liffid = window.liffid
Vue.use(Vuetify, {
  theme: {
    primary: "#977b4b"
  }
});

Vue.prototype.$liff = window.liff
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
